import { toResult, type Fetched } from './client';
import type { ApiProblem } from './problem';

/**
 * Sends one all-or-nothing content batch. A row deleted meanwhile fails the whole batch with a 404
 * naming its item (`items[3].uniqueId`); that item is dropped and the rest sent again, as often as items
 * go missing (at most once per item). Resolves with the problem that stopped it, or null.
 */
export async function sendBatchSkippingMissing<I>(
  items: I[],
  send: (items: I[]) => Promise<Fetched<unknown>>,
): Promise<ApiProblem | null> {
  let rest = items;
  for (let pass = 0; pass <= items.length; pass += 1) {
    const { error } = await toResult(send(rest));
    const missing = error?.status === 404 ? /^items\[(\d+)\]/.exec(error.field ?? '') : null;
    if (!missing || Number(missing[1]) >= rest.length) return error;
    rest = rest.filter((_, i) => i !== Number(missing[1]));
    if (rest.length === 0) return null;
  }
  return null;
}
